module.exports = __webpack_public_path__ + "img/event-mockup.39b64594.png";